import { isValidLocale } from '@/config/market-configurations';

export default function getLocaleFromPathname(pathname: string) {
    const locale = pathname.split('/')[1];

    return isValidLocale(locale) ? locale : '';
}
